import { ContextService } from '../../services/context_service';
import { getNoStandortMessage } from '../datenauswertung/elements/getNoStandortMessage';
import { getStandorte } from '../../helpers/getStandorte';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { StandorteFahrzeuge } from './detail/StandorteFahrzeuge';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import { WTabsScrollbar } from '../../core/tabs/WTabsScrollbar';
import { getStandorteGruppenTabRoutings } from './functions/StandorteGruppen';

interface DateneingabeFahrzeugeTabsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface DateneingabeFahrzeugeTabsState {
    tabIndex: number;
    tabIndex2: number;
    tabList: any;
}

export class DateneingabeFahrzeugeTabs extends React.Component<DateneingabeFahrzeugeTabsProps, DateneingabeFahrzeugeTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: 0,
            tabIndex2: 0,
            tabList: null
        };
        this.tabList = React.createRef();
        this.onUpdateScrollbar = this.onUpdateScrollbar.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private tabList: any;

    componentDidMount(): void {
        this.checkRouting();
        this.checkTabIndex();
        this.setState({ tabList: this.tabList.current });
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
            this.checkTabIndex();
        }
    }

    checkTabIndex() {
        const tabIndex = this.contextService.get('tabIdxDateneingabeFahrzeuge') || 0;
        const tabIndex2 = this.contextService.get(`tabIdxDateneingabeFahrzeuge_${tabIndex}`) || 0;
        if (tabIndex !== this.state.tabIndex) {
            this.setState({ tabIndex });
        }
        if (tabIndex2 !== this.state.tabIndex2) {
            this.setState({ tabIndex2 });
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENEINGABE_FAHRZEUGE;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
        const tabName2: string = RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM;
        if (routing.path && routing.path[tabName2] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName2) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex2(routing.path[tabName2], routing);
            if (this.state.tabIndex2 === routing.path[tabName2]) {
                if (routing.path.terminateOn === tabName2) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex2(routing.path[tabName2], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENEINGABE_FAHRZEUGE;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDateneingabeFahrzeuge', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    setTabIndex2(tabIndex2: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex2 !== tabIndex2) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName2: string = RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM;
            if (routing.path && routing.path[tabName2] === undefined) {
                // init default tabIndex2
                routing.path[tabName2] = this.state.tabIndex2;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex2 }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(`tabIdxDateneingabeFahrzeuge_${this.state.tabIndex}`, tabIndex2);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    onUpdateScrollbar(): void {
        this.setState({ tabList: this.tabList.current });
    }

    render(): JSX.Element {
        const standorte: any[] = getStandorte(this.props.data) || [];
        if (standorte.length === 0) {
            return getNoStandortMessage();
        }

        const basisRouting = RoutingIDs.ROUTE_DATENEINGABE_FAHRZEUGE;
        const basisTab = RoutingIDs.TABS_DATENEINGABE_FAHRZEUGE;
        const tabRoutings = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab);

        return (
            <div>
                {this.state.tabList &&
                    <WTabsScrollbar
                        tabList={this.state.tabList}
                    />
                }
                <Tabs
                    className={'tabs-dateneingabe'}
                    selectedIndex={this.state.tabIndex}
                    onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
                >
                    <TabList
                        style={{ display: 'none', whiteSpace: 'nowrap', overflow: 'auto hidden' }}
                        onScroll={this.onUpdateScrollbar}
                        ref={this.tabList}
                    >
                        {tabRoutings.map((r: any, idx: number) =>
                            <Tab key={`tab-${idx}`}>{r.name}</Tab>
                        )}
                    </TabList>
                    {tabRoutings.map((r: any, idx: number) => this.renderTabPanel(idx, r))}
                </Tabs>
            </div>
        );
    }

    renderTabPanel(idx: number, routing: any): JSX.Element {
        if (Array.isArray(routing.children)) {
            return this.renderTabPanelGruppe(idx, routing);
        } else {
            return this.renderTabPanelSingle(idx, undefined, routing);
        }
    }

    renderTabPanelGruppe(idx: number, routing: any): JSX.Element {
        const tabRoutings = routing && routing.path && Array.isArray(routing.children) ? routing.children : [];
        return <TabPanel
            key={`panel-${idx}`}
            style={{
                flexDirection: 'column', display: 'flex', minHeight: 0,
                flex: this.state.tabIndex === idx ? 1 : 0
            }}
        >
            <Tabs
                className={'tabs-dateneingabe'}
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex2}
                onSelect={(tabIndex2, lastIndex, event) => this.setTabIndex2(tabIndex2, tabRoutings[tabIndex2])}
            >
                <TabList>
                    {tabRoutings.map((r: any, idx2: number) => <Tab key={`tab-${idx}-${idx2}`}>{r.name}</Tab>)}
                </TabList>
                {tabRoutings.map((r: any, idx2: number) => this.renderTabPanelSingle(idx, idx2, r))}
            </Tabs >
        </TabPanel>;
    }

    renderTabPanelSingle(idx: number, idx2: number, routing: any): JSX.Element {
        const dataRow = routing.dataRow || {};
        return <TabPanel
            key={idx2 >= 0 ? `panel-${idx}-${idx2}` : `panel-${idx}`}
            style={{
                flexDirection: 'column', display: 'flex', minHeight: 0,
                flex: this.state.tabIndex === idx && (idx2 >= 0 ? this.state.tabIndex2 === idx2 : true) ? 1 : 0
            }}
        >
            <StandorteFahrzeuge
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
                routing={this.props.routing}
                standortSelected={dataRow}
            />
        </TabPanel>;
    }
}
